import React, { useEffect } from 'react';
import { useParams, useSearchParams, Navigate } from 'react-router-dom';
import { api } from '../lib/api';

/**
 * Enlace corto de las publicaciones sociales: /p/:id?v=A&ch=facebook
 * Registra el clic (fire-and-forget) para el A/B testing y redirige a la ficha.
 */
export default function ShortLink() {
  const { id } = useParams();
  const [params] = useSearchParams();

  useEffect(() => {
    const v = params.get('v') || 'A';
    const ch = params.get('ch') || 'unknown';
    // fire-and-forget: nunca bloquea la navegación
    try {
      api.registerDistributionClick({ property_id: id, v, ch }).catch(() => {});
    } catch (_) { /* noop */ }
  }, [id, params]);

  return <Navigate to={`/propiedad/${id}`} replace />;
}
